<template>
  <v-container v-if="!isExpired" fluid class="inbox-container pa-0 ma-0">
    <!-- Modern Header Section -->
    <v-row v-if="showHeader" class="pa-0 ma-0 px-3 mb-4">
      <v-col cols="12" class="pa-0">
        <div class="header-section mb-4" style="position: relative;">
          <v-btn icon small class="header-close-btn" @click="dismissHeader">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
          <v-container fluid class="px-3">
            <v-row align="center" class="pa-0 ma-0">
              <v-col cols="12" md="8" class="d-flex align-center pa-0">
                <div class="header-icon-wrapper mr-4">
                  <v-icon size="32" color="#FFFFFF"
                    >mdi-message-text-outline</v-icon
                  >
                </div>
                <div>
                  <h1 class="page-title mb-1">WhatsApp Inbox</h1>
                  <p class="page-subtitle mb-0">
                    Manage all your WhatsApp conversations in one place
                  </p>
                </div>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="pa-0 d-flex align-center flex-wrap justify-start justify-md-end"
                style="gap: 8px;"
              >
                <v-chip small color="rgba(255,255,255,0.2)" text-color="white">
                  <v-icon small left color="white">mdi-whatsapp</v-icon>WhatsApp
                </v-chip>
                <v-chip small color="rgba(255,255,255,0.2)" text-color="white">
                  <v-icon small left color="white">mdi-credit-card</v-icon>
                  {{ $store.getters.companyDetails.whatsappCredits || 0 }}
                </v-chip>
                <v-btn
                  to="/whatsapp-settings"
                  small
                  outlined
                  color="white"
                  class="white--text"
                >
                  <v-icon small left color="white">mdi-plus</v-icon>
                  Buy Credits
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="mt-4">
              <v-col cols="12" class="pa-0">
                <div class="feature-pills-container">
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white">mdi-inbox</v-icon>
                    Shared Inbox
                  </div>
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white">mdi-reply</v-icon>
                    Quick Replies
                  </div>
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white"
                      >mdi-file-document-outline</v-icon
                    >
                    Templates
                  </div>
                  <div class="feature-pill">
                    <v-icon small class="mr-2" color="white"
                      >mdi-history</v-icon
                    >
                    Message History
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>
    </v-row>

    <v-layout row wrap style="margin: 0px">
      <v-flex xs12 sm12 md12 style="padding-bottom: 1%;padding-top:1%">
        <WhatsappConnector
          v-if="!isConnected && !whatsappRegistered"
          :is-connected="isConnected"
          :whatsapp-registered="whatsappRegistered"
          :set-chat-show="setChatShow"
        />
      </v-flex>

      <v-container
        v-if="!isConnected && !whatsappRegistered && !initialInboxDialog"
        fluid
        class="whiteBackGround customBorderRadius"
      >
        <first-page
          :img-src="imgSrc"
          :dialog-name.sync="initialInboxDialog"
          :points="points"
          :headline="headline"
        ></first-page>
      </v-container>
      <WhatsappChat
        v-if="isConnected && whatsappRegistered"
        :send-message="sendMessage"
        :wapp-access="userDetails.accessToken"
        :godial-user="user"
      />
    </v-layout>

    <div style="padding-top: 20vh;">
      <PayWallCard
        title="Unlock WhatsApp Business"
        description="Get access to powerful WhatsApp features to engage customers"
        badge="Premium Feature"
        badge-icon="mdi-whatsapp"
        badge-color="success"
        :features="whatsappFeatures"
        button-text="Upgrade Now"
        @update-is-expired="handlePaywallUpdate"
      />
    </div>
  </v-container>

  <v-container v-else fluid text-xs-center>
    <PayWallCard
      title="Unlock WhatsApp Business"
      description="Get access to powerful WhatsApp features to engage customers"
      badge="Premium Feature"
      badge-icon="mdi-whatsapp"
      badge-color="success"
      :features="whatsappFeatures"
      button-text="Upgrade Now"
      @update-is-expired="handlePaywallUpdate"
    />
  </v-container>
</template>
<script>
import axios from "axios";
// import { mdiAlertBox } from "@mdi/js";
import { mapGetters } from "vuex";
import WhatsappChat from "@/components/whatsappChat";
import WhatsappConnector from "../../components/whatsappConnector.vue";
import PayWallCard from "@/components/payWallCard.vue";
import firstPage from "@/components/firstPage.vue";
export default {
  components: {
    WhatsappChat,
    WhatsappConnector,
    firstPage,
    PayWallCard,
  },
  data() {
    return {
      showHeader: false,
      isExpired: false, // Ensure isExpired is in data()
      initialInboxDialog: false,
      isConnected: false,
      whatsappRegistered: false,
      userDetails: {}, //To store whatsapp user details for authentication
      phoneNoId: "",
      sendMessageTo: "",
      businessId: "",
      message: "",
      headline: "Simplify Customer Support with Shared inbox",
      points: [
        "Centralized Command Center: See all your team's customer chats in one convenient dashboard.",
        "Targeted Communication: Select specific contacts from a pre-defined list to send personalized messages directly from the inbox.",
        "Actionable Insights: Gain valuable oversight into team communication and customer trends, allowing you to refine your WhatsApp strategy.",
      ],
      whatsappFeatures: [
        "Shared inbox for team collaboration",
        "Broadcast messages to contacts",
        "Automated message templates",
        "Real-time chat analytics",
      ],
      // icons: {
      //     mdiAlertBox,
      // },
      goUser: {},
    };
  },
  computed: {
    ...mapGetters(["ENDPOINT", "user", "companyDetails", "selectedTeam"]),
    imgSrc() {
      return require("@/assets/goinbox.svg");
    },
  },
  async mounted() {
    this.showHeader =
      localStorage.getItem("whatsappInboxHeaderDismissed") !== "true";
    // Look for integration details
    const getIntegration = await this.$http.get(
      `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.user.companyId}&filter[where][type]=whatsapp`,
    );
    if (
      getIntegration.body.length &&
      getIntegration.body[0].config.initializeDone
    ) {
      this.setChatShow();
    }
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("whatsappInboxHeaderDismissed", "true");
    },
    // checkLoginStatus() {
    //   return new Promise(async (resolve, reject) => {
    //     try {
    //       const response = await new Promise(FB.getLoginStatus);

    //       if (response.status === "connected") {
    //         this.isConnected = true;
    //       }
    //       console.log("User: ", response);
    //       this.userDetails = response.authResponse;
    //       // Getting integration details to check if integration details already exists
    //       const getIntegration = await axios.get(
    //         `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.user.companyId}&filter[where][type]=whatsapp&access_token=${this.user.token}`
    //       );
    //       console.log("getIntegration response: ", getIntegration.data);

    //       if (getIntegration.data.length) {
    //         const data = {
    //           config: {
    //             ...getIntegration.data.config,
    //             tempAccessToken: this.userDetails,
    //             tokenGenerateTime: new Date(),
    //           },
    //         };
    //         const updateIntegration = await axios.patch(
    //           `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.user.companyId}&filter[where][type]=whatsapp&access_token=${this.user.token}`,
    //           data
    //         );
    //         console.log("Updated Integration data: ", updateIntegration.data);
    //       }

    //       resolve(response);
    //     } catch (error) {
    //       console.error("Error in checkLoginStatus:", error);
    //       reject(error);
    //     }
    //   });
    // },

    handlePaywallUpdate(expiredStatus) {
      this.isExpired = expiredStatus;
    },

    // To send template messages to whatsapp
    async sendMessage(accessToken, contactNumber) {
      try {
        const getUser = await axios.get(
          `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.user.companyId}&filter[where][type]=whatsapp&access_token=${this.user.token}`,
        );

        const data = {
          messaging_product: "whatsapp",
          to: contactNumber,
          type: "template",
          template: {
            name: "hello_world",
            language: {
              code: "en_US",
            },
          },
        };
        const response = await axios.post(
          `https://graph.facebook.com/v18.0/${getUser.data[0].config.whatsappNoId}/messages`,
          data,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (response.data.messages.length) {
          this.$swal({
            type: "success",
            text: "Message sent successfully",
          });
        }
      } catch (e) {
        console.log("send messge error: ", e);
        this.$swal({
          type: "error",
          text: e.response.data.error.message,
        });
      }
    },

    // Send text msg on whatsapp
    // async sendTextMessage(accessToken, contactNumber, message) {
    //   // console.log("Send message fired");
    //   // console.log("access Token: ", accessToken);
    //   //   const contactNumber = this.sendMessageTo;
    //   const getUser = await axios.get(
    //     `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.user.companyId}&filter[where][type]=whatsapp&access_token=${this.user.token}`
    //   );
    //   const data = {
    //     recipient_type: "individual",
    //     to: contactNumber,
    //     type: "text",
    //     text: {
    //       body: message,
    //     },
    //   };
    //   console.log("data sending: ", data);
    //   // const headers = [`Authorization: Bearer ${accessToken}`, 'Content-Type: application/json'];
    //   const response = await axios.post(
    //     `https://graph.facebook.com/v18.0/${getUser.data[0].config.whatsappNoId}/v1/messages`,
    //     data,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${accessToken}`,
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   );

    //   if (response.data.messages.length) {
    //     this.$swal({
    //       type: "success",
    //       text: "Message sent successfully",
    //     });
    //   } else {
    //     this.$swal({
    //       type: "error",
    //       text: "An error occurred while sending message. Please try again!",
    //     });
    //   }
    //   console.log("Message response: ", response);
    // },
    // async saveWhatsappDetails() {
    //     console.log("server endpoint: ", this.ENDPOINT);
    //     console.log("user: ", this.user);
    //     const data = {
    //         whatsappNoId: this.phoneNoId,
    //         whatsappBusinessId: this.businessId
    //     }
    //     try {
    //         const resp = await axios.patch(`${this.ENDPOINT}/accounts/${this.user.id}?access_token=${this.user.token}`, data);
    //         console.log("Response from account: ", resp.data);
    //         if (resp.data) this.whatsappRegistered = true;
    //     } catch (error) {
    //         console.log("Error: ", error);
    //         this.$swal({
    //             type: "error",
    //             text: "An error occurred. Please try again!",
    //         })
    //     }

    // },
    // async saveWhatsappDetails() {
    //   console.log("server endpoint: ", this.ENDPOINT);
    //   console.log("user: ", this.user);
    //   // console.log("accessToken: ", this.userDetails);

    //   const data = {
    //     type: "whatsapp",
    //     enabled: true,
    //     config: {
    //       whatsappNoId: this.phoneNoId,
    //       whatsappBusinessId: this.businessId,
    //       whatsappMessageTemplates: ["hello_world"],
    //       tempAccessToken: this.userDetails.authResponse,
    //       tokenGenerateTime: new Date(),
    //     },
    //     companyId: this.user.companyId,
    //   };
    //   try {
    //     const resp = await axios.post(
    //       `${this.ENDPOINT}/integrations?access_token=${this.user.token}`,
    //       data
    //     );
    //     console.log("Response from account: ", resp.data);
    //     if (resp.data) this.whatsappRegistered = true;
    //   } catch (error) {
    //     console.log("Error: ", error);
    //     this.$swal({
    //       type: "error",
    //       text: "An error occurred. Please try again!",
    //     });
    //   }
    // },

    setChatShow() {
      this.isConnected = true;
      this.whatsappRegistered = true;
    },
  },
};
</script>
<style scoped>
.inbox-container {
  background-color: var(--v-background-base, #f5f5f5);
}

.theme--dark .inbox-container {
  background-color: #121212 !important;
}

.credit-img {
  max-width: 1.5rem;
  height: auto;
}

.custom-color {
  color: white;
  font-weight: 600;
  font-size: 1.2rem;
}

.fb-button {
  color: white;
}

.intframe {
  height: 100vh;
  width: 100%;
}
</style>
